module.exports = "/images/it-82.svg?41d65832b7e9c803a697978cb976b1df";